import React from 'react';
import styled from 'styled-components';
import { useButton } from '@react-aria/button';
import { useRef } from 'react';
import { useFocusRing } from '@react-aria/focus';
import { mergeProps } from '@react-aria/utils';

// Props interface
interface IButtonProps {
    children: React.ReactNode;
    isDisabled?: boolean;
}

// Styled-components for Button
const StyledButton = styled.button<IButtonProps>`
    padding: 0.5rem;
    border-radius: 9999px;
    background-color: transparent;
    border: none;
    outline: none;
    cursor: ${({ isDisabled }) => (isDisabled ? 'not-allowed' : 'pointer')};

    &:focus {
        outline: none !important;
    }
`;

export const CalendarButton: React.FC<IButtonProps> = (props) => {
    const { children, isDisabled = false } = props;
    const ref = useRef<HTMLButtonElement>(null);
    const { buttonProps } = useButton(props, ref);
    const { focusProps, isFocusVisible } = useFocusRing();

    return (
        <StyledButton
            {...mergeProps(buttonProps, focusProps)}
            ref={ref}
            isDisabled={isDisabled}
            isFocusVisible={isFocusVisible}
        >
            {children}
        </StyledButton>
    );
};
